module.exports = {
    zhactive:true,
    enactive:false,
    requestTimeout:5000,
    messageDuration: 2000, 

    storage: "localStorage", //token存储方式
    tokenTableName: "BEAUTIFUL-VUE-SPEAKER", //储存token的名称
};
  